import { Directive, ElementRef, OnInit , Input } from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';

@Directive({
  selector: '[canAcess]'
})
export class CanAcessDirective implements OnInit {

  @Input('canAcess') permission: any[]; // Required permission passed in

  constructor(private el: ElementRef, private authenticationService: AuthenticationService) { }

  ngOnInit() {
    if (!this.authenticationService.hasPermission(this.permission)) {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
